import React from 'react';

const IconSalir = (props) => (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.9219 4.00195H5.92188V18.002C5.92188 18.5324 6.13259 19.0411 6.50766 19.4162C6.88273 19.7912 7.39144 20.002 7.92188 20.002H15.9219M16.9219 15.002L19.9219 12.002M19.9219 12.002L16.9219 9.00195M19.9219 12.002H9.92188" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

);

export default IconSalir;

